<template>
  <div>
    <div class="items" ref="container">
      <div v-if="items.length === 0 && !query" class="no-variables">
        {{ $t('variables.noVariables') }}
      </div>
      <div v-else-if="items.length === 0 && query" class="no-variables create-new">
        {{ $t('variables.createNew', { variable: query }) }}
      </div>
      <div
        v-for="(item, index) in items"
        :key="index"
        class="item"
        :class="{ 'is-selected': index === selectedIndex }"
        @mouseenter="onMouseEnter(index)"
        @click="selectItem(index)"
      >
        <div class="variable-name">
          <span class="variable-name-text">{{ item }}</span>
          <span v-if="isNewVariable(item) || getVariableType(item)" class="variable-meta">
            <span v-if="isNewVariable(item)" class="new-text">{{ $t('variables.new') }}</span>
            <span v-if="getVariableType(item)" class="variable-type">{{ getVariableType(item) }}</span>
          </span>
        </div>
        <div v-if="!isNewVariable(item)" class="action-icon-wrapper" @click.stop="toggleActionMenu(index, $event)">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            xmlns:xlink="http://www.w3.org/1999/xlink"
            aria-hidden="true"
            role="img"
            width="16px"
            height="16px"
            preserveAspectRatio="xMidYMid meet"
            viewBox="0 0 16 16"
            class="action-icon"
          >
            <g fill="none">
              <path
                d="M5.33335 3.33317V3.33984M5.33335 7.99984V8.0065M5.33335 12.6665V12.6732M5.33335 3.99984C5.15654 3.99984 4.98697 3.9296 4.86195 3.80458C4.73693 3.67955 4.66669 3.50998 4.66669 3.33317C4.66669 3.15636 4.73693 2.98679 4.86195 2.86177C4.98697 2.73674 5.15654 2.6665 5.33335 2.6665C5.51016 2.6665 5.67973 2.73674 5.80476 2.86177C5.92978 2.98679 6.00002 3.15636 6.00002 3.33317C6.00002 3.50998 5.92978 3.67955 5.80476 3.80458C5.67973 3.9296 5.51016 3.99984 5.33335 3.99984ZM5.33335 8.6665C5.15654 8.6665 4.98697 8.59627 4.86195 8.47124C4.73693 8.34622 4.66669 8.17665 4.66669 7.99984C4.66669 7.82303 4.73693 7.65346 4.86195 7.52843C4.98697 7.40341 5.15654 7.33317 5.33335 7.33317C5.51016 7.33317 5.67973 7.40341 5.80476 7.52843C5.92978 7.65346 6.00002 7.82303 6.00002 7.99984C6.00002 8.17665 5.92978 8.34622 5.80476 8.47124C5.67973 8.59627 5.51016 8.6665 5.33335 8.6665ZM5.33335 13.3332C5.15654 13.3332 4.98697 13.2629 4.86195 13.1379C4.73693 13.0129 4.66669 12.8433 4.66669 12.6665C4.66669 12.4897 4.73693 12.3201 4.86195 12.1951C4.98697 12.0701 5.15654 11.9998 5.33335 11.9998C5.51016 11.9998 5.67973 12.0701 5.80476 12.1951C5.92978 12.3201 6.00002 12.4897 6.00002 12.6665C6.00002 12.8433 5.92978 13.0129 5.80476 13.1379C5.67973 13.2629 5.51016 13.3332 5.33335 13.3332Z"
                stroke="currentColor"
                stroke-width="1.33333"
                stroke-linecap="round"
                stroke-linejoin="round"
              ></path>
              <path
                d="M10.6667 3.33317V3.33984M10.6667 7.99984V8.0065M10.6667 12.6665V12.6732M10.6667 3.99984C10.4899 3.99984 10.3203 3.9296 10.1953 3.80458C10.0702 3.67955 10 3.50998 10 3.33317C10 3.15636 10.0702 2.98679 10.1953 2.86177C10.3203 2.73674 10.4899 2.6665 10.6667 2.6665C10.8435 2.6665 11.013 2.73674 11.1381 2.86177C11.2631 2.98679 11.3333 3.15636 11.3333 3.33317C11.3333 3.50998 11.2631 3.67955 11.1381 3.80458C11.013 3.9296 10.8435 3.99984 10.6667 3.99984ZM10.6667 8.6665C10.4899 8.6665 10.3203 8.59627 10.1953 8.47124C10.0702 8.34622 10 8.17665 10 7.99984C10 7.82303 10.0702 7.65346 10.1953 7.52843C10.3203 7.40341 10.4899 7.33317 10.6667 7.33317C10.8435 7.33317 11.013 7.40341 11.1381 7.52843C11.2631 7.65346 11.3333 7.82303 11.3333 7.99984C11.3333 8.17665 11.2631 8.34622 11.1381 8.47124C11.013 8.59627 10.8435 8.6665 10.6667 8.6665ZM10.6667 13.3332C10.4899 13.3332 10.3203 13.2629 10.1953 13.1379C10.0702 13.0129 10 12.8433 10 12.6665C10 12.4897 10.0702 12.3201 10.1953 12.1951C10.3203 12.0701 10.4899 11.9998 10.6667 11.9998C10.8435 11.9998 11.013 12.0701 11.1381 12.1951C11.2631 12.3201 11.3333 12.4897 11.3333 12.6665C11.3333 12.8433 11.2631 13.0129 11.1381 13.1379C11.013 13.2629 10.8435 13.3332 10.6667 13.3332Z"
                stroke="currentColor"
                stroke-width="1.33333"
                stroke-linecap="round"
                stroke-linejoin="round"
              ></path>
            </g>
          </svg>
        </div>
      </div>
      <div
        v-if="items.length === 0 && query"
        class="item create-new-item"
        :class="{ 'is-selected': selectedIndex === 0 }"
        @mouseenter="onMouseEnter(0)"
        @click="selectItem(-1)"
      >
        <div class="variable-name">{{ $t('variables.createNew', { variable: query }) }}</div>
      </div>
    </div>
    <VariableActionMenu
      :open="actionMenuIndex !== null"
      :targetElement="actionMenuTargetElement"
      :onModify="actionMenuIndex !== null ? () => handleModify(items[actionMenuIndex], actionMenuIndex) : undefined"
      :onDelete="actionMenuIndex !== null ? () => handleDelete(items[actionMenuIndex], actionMenuIndex) : undefined"
      @close="actionMenuIndex = null"
    />
  </div>
</template>

<script lang="ts">
import { Component, Prop, Ref, Vue, Watch } from 'vue-property-decorator'
import VariableActionMenu from './VariableActionMenu.vue'
import { mapApiTypeToUI } from '@/util/variable-type-utils'

@Component({
  components: {
    VariableActionMenu
  }
})
export default class VariableList extends Vue {
  @Prop() private items!: string[]
  @Prop() private command!: Function
  @Prop() private query!: string
  @Prop({ default: () => [] }) private filteredItems!: Array<{
    variable: string
    variableType?: string
    isNew?: boolean
    variableId?: string
    spaceVariable?: any
  }>
  @Prop() private onNewVariable?: (variableName: string) => void
  @Prop() private onModify?: (variable: string, variableId?: string, spaceVariable?: any) => void
  @Prop() private onDelete?: (variable: string, variableId?: string, spaceVariable?: any) => void
  @Prop() private onActionMenuOpen?: () => void
  private selectedIndex = 0
  private keyboardNavigationActive = false
  private keyboardNavigationTimeout?: any
  private actionMenuIndex: number | null = null
  private actionMenuTargetElement: HTMLElement | null = null

  @Ref('container') containerRef!: HTMLDivElement

  @Watch('items') watchItems() {
    this.selectedIndex = 0
  }

  @Watch('query') watchQuery() {
    this.selectedIndex = 0
  }

  onKeyDown(event: KeyboardEvent) {
    const totalItems = this.items.length + (this.query && this.items.length === 0 ? 1 : 0)

    // Space key should be prevented - spaces not allowed in variable names
    if (event.key === ' ' || event.key === 'Space') {
      event.preventDefault()
      event.stopPropagation()
      return true // Prevent space from being typed, keep dropdown open
    }

    if (event.key === 'ArrowUp') {
      event.preventDefault()
      event.stopPropagation()
      this.setActiveKeyboardNavigation()
      this.selectedIndex = (this.selectedIndex + totalItems - 1) % Math.max(totalItems, 1)
      this.scrollIfNeeded()
      return true
    }

    if (event.key === 'ArrowDown') {
      event.preventDefault()
      event.stopPropagation()
      this.setActiveKeyboardNavigation()
      this.selectedIndex = (this.selectedIndex + 1) % Math.max(totalItems, 1)
      this.scrollIfNeeded()
      return true
    }

    if (event.key === 'Enter') {
      event.preventDefault()
      event.stopPropagation()
      if (this.items.length > 0) {
        this.selectItem(this.selectedIndex)
      } else if (this.query) {
        // Create new variable
        this.selectItem(-1)
      }
      return true
    }

    if (event.key === 'Escape') {
      event.preventDefault()
      event.stopPropagation()
      return true
    }

    return false
  }

  onMouseEnter(index: number) {
    if (!this.keyboardNavigationActive) {
      this.selectedIndex = index
    }
  }

  selectItem(index: number) {
    if (index === -1 && this.query) {
      const trimmedQuery = this.query.trim()
      // Don't create new variable if query contains invalid characters
      if (!this.isValidVariableName(trimmedQuery)) {
        return
      }
      // Create new variable from query
      if (this.onNewVariable) {
        this.onNewVariable(trimmedQuery)
      } else {
        this.command({ variable: trimmedQuery })
      }
      return
    }

    const variable = this.items[index]
    if (!variable) {
      return
    }

    // Optimize: only check isNew if onNewVariable callback exists
    if (this.onNewVariable) {
      // Use find with early return for better performance
      const item = this.filteredItems.find(item => item.variable.toLowerCase() === variable.toLowerCase())
      if (item?.isNew) {
        this.onNewVariable(variable)
        return
      }
    }

    this.command({ variable })
  }

  // Cache lookup result to avoid duplicate find operations
  private getVariableItem(variable: string) {
    const variableLower = variable.toLowerCase()
    return this.filteredItems.find(item => item.variable.toLowerCase() === variableLower)
  }

  isNewVariable(variable: string): boolean {
    return this.getVariableItem(variable)?.isNew || false
  }

  private isValidVariableName(name: string): boolean {
    return /^[A-Za-z0-9_]+$/.test(name)
  }

  getVariableType(variable: string): string | undefined {
    const type = this.getVariableItem(variable)?.variableType
    if (!type) return undefined
    return mapApiTypeToUI(type)
  }

  scrollIfNeeded() {
    if (!this.containerRef) return

    const items = this.containerRef.querySelectorAll('.item')
    const selectedItem = items[this.selectedIndex] as HTMLElement

    if (selectedItem) {
      const elementRect = selectedItem.getBoundingClientRect()
      const boxRect = this.containerRef.getBoundingClientRect()
      const scrollPadding = 8

      if (elementRect.bottom > boxRect.bottom) {
        this.containerRef.scrollBy({
          top: elementRect.bottom - boxRect.bottom + scrollPadding,
          behavior: 'smooth'
        })
      } else if (elementRect.top < boxRect.top) {
        this.containerRef.scrollBy({
          top: elementRect.top - boxRect.top - scrollPadding,
          behavior: 'smooth'
        })
      }
    }
  }

  setActiveKeyboardNavigation() {
    this.keyboardNavigationActive = true
    if (this.keyboardNavigationTimeout) {
      clearTimeout(this.keyboardNavigationTimeout)
    }
    this.keyboardNavigationTimeout = setTimeout(() => {
      this.keyboardNavigationActive = false
    }, 200)
  }

  toggleActionMenu(index: number, event: MouseEvent) {
    event.stopPropagation()
    if (this.actionMenuIndex === index) {
      this.actionMenuIndex = null
      this.actionMenuTargetElement = null
    } else {
      // Get the target element from the event
      const target = event.currentTarget as HTMLElement
      this.actionMenuTargetElement = target
      this.actionMenuIndex = index
      // Notify parent that action menu is opening to prevent popup from hiding
      if (this.onActionMenuOpen) {
        this.onActionMenuOpen()
      }
    }
  }

  handleModify(variable: string, _index: number) {
    const item = this.getVariableItem(variable)
    if (this.onModify && item) {
      this.onModify(variable, item.variableId, item.spaceVariable)
    }
    this.actionMenuIndex = null
    this.actionMenuTargetElement = null
  }

  handleDelete(variable: string, _index: number) {
    const item = this.getVariableItem(variable)
    if (this.onDelete && item) {
      this.onDelete(variable, item.variableId, item.spaceVariable)
    }
    this.actionMenuIndex = null
    this.actionMenuTargetElement = null
  }
}
</script>

<style lang="scss" scoped>
@use '@/assets/styles' as *;

.items {
  @include notch-style-floating;
  position: relative;
  background: $notch-color-neutral-grey-000;
  overflow: hidden;
  border-radius: $notch-radius-2x;
  padding: $notch-space-2x;
  width: $notch-space-90x;
  max-height: $notch-space-83x;
  overflow-y: auto;
}

.item {
  display: flex;
  align-items: center;
  width: 100%;
  border-radius: $notch-radius-full;
  padding: $notch-space-2x $notch-space-3x;
  cursor: pointer;

  &.is-selected {
    background: $notch-color-neutral-sand-100;
  }

  .variable-name {
    @include notch-text-label-light-M;
    color: $notch-color-neutral-grey-900;
    display: flex;
    align-items: center;
    flex: 1;
    min-width: 0;

    .variable-name-text {
      flex: 0 1 auto;
      min-width: 0;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }

    .new-text {
      @include notch-text-label-light-XS;
      font-style: italic;
      background-color: $notch-color-semantic-info-100;
      color: $notch-color-semantic-info-800;
      padding: $notch-space-05x $notch-space-2x;
      border-radius: $notch-radius-1x;
      flex-shrink: 0;
    }

    .variable-type {
      @include notch-text-label-light-XS;
      color: $notch-color-neutral-sand-600;
      flex-shrink: 0;
    }

    .variable-meta {
      margin-left: auto;
      display: inline-flex;
      align-items: center;
      gap: $notch-space-1x;
    }
  }

  .action-icon-wrapper {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    width: $notch-space-6x;
    height: $notch-space-6x;
    margin-left: $notch-space-2x;
    flex-shrink: 0;
    cursor: pointer;
    border-radius: $notch-radius-1x;
    transition: background-color 0.15s ease;

    &:hover {
      background: $notch-color-neutral-sand-100;
    }

    .action-icon {
      width: 16px;
      height: 16px;
      color: $notch-color-neutral-sand-600;
    }
  }
}

.no-variables {
  @include notch-text-label-light-S;
  color: $notch-color-neutral-sand-600;
  padding: $notch-space-2x $notch-space-3x;
  text-align: center;

  &.create-new {
    cursor: pointer;

    &:hover {
      background: $notch-color-neutral-sand-100;
      border-radius: $notch-radius-full;
    }
  }
}

.create-new-item {
  cursor: pointer;
}
</style>
